import { useContext } from 'react';

import { GaugeChartSizeContext } from '../contexts/GaugeChartSizeContext.js';

export const useGaugeChartSizeContext = () => useContext(GaugeChartSizeContext);
